import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppConfig } from '../context/AppConfigContext';
import PublicRegister from './PublicRegister';

/**
 * Root landing dispatcher.
 * - Single-tenant deploy (e.g. ring.tacoloco.food → SINGLE_TENANT_BRAND_ID set):
 *   show the customer registration/login page directly. Staff/admin/superadmin
 *   sign-ins remain on their dedicated paths (/staff/login, /admin/login, …).
 * - Multi-tenant deploy (lazo.app & co): show the SaaS landing → BrandSignup.
 */
export default function RootLanding() {
  const cfg = useAppConfig();
  if (!cfg.loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#111114' }}>
        <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#D44E20' }} />
      </div>
    );
  }
  if (cfg.single_tenant) {
    return <PublicRegister />;
  }
  return <Navigate to="/signup" replace />;
}
